import { SUBMOTIVE3_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSubmotive3List } from './hook';
import { Submotive3ListProps } from './props';

export const Submotive3List = ({ filters }: Submotive3ListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSubmotive3List(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SUBMOTIVE3_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
